<script setup>
import { computed, ref, watch } from 'vue';

const props = defineProps({
    modelValue: {
        type: [String, Boolean],
        default: false
    },
    inputId: {
        type: String,
        default: ''
    },
    label: {
        type: String,
        default: ''
    },
    spanText: {
        type: String,
        default: ''
    },
    spanSize: {
        type: String,
        default: '0.875rem'
    },
    required: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    },
    marginTop: {
        type: String,
        default: '0'
    },
    marginBottom: {
        type: String,
        default: '0'
    },
    marginLeft: {
        type: String,
        default: '0'
    },
    marginRight: {
        type: String,
        default: '0'
    },
    labelRightmargin: {
        type: String,
        default: '2rem'
    },
    visible: {
        type: Boolean,
        default: true
    },
    readonly: {
        type: Boolean,
        default: false
    },
    errmsg: {
        type: String,
        default: ''
    },
    labelEmpty: {
        type: Boolean,
        default: false
    },
    underline: {
        type: Boolean,
        default: false
    },
    isReturnBoolean: {
        type: Boolean,
        default: false
    },
    padding: {
        type: String,
        default: '0.1rem'
    },
    width: {
        type: String,
        default: ''
    },
    height: {
        type: String,
        default: '2.4rem'
    }
});

const emit = defineEmits(['update:modelValue', 'change']);
const errMessage = ref(props.errmsg);
const ValidationMsg = ref('');
const isReadonly = computed(() => props.readonly);
const isVisible = computed(() => props.visible);
const isChecked = ref(props.modelValue === 'Y' || props.modelValue === true || props.modelValue === '-1');

watch(
    () => props.errmsg,
    (newVal) => {
        ValidationMsg.value = newVal || '';
        errMessage.value = newVal || '';
    },
    { immediate: true, deep: true }
);

watch(
    () => props.modelValue,
    (newValue) => {
        isChecked.value = newValue === 'Y' || newValue === true || newValue === '-1';
    },
    { immediate: true }
);

const onChange = (e) => {
    if (isReadonly.value) return;

    const checked = e?.target?.checked === true;
    isChecked.value = checked;

    const newValue = props.isReturnBoolean ? checked : checked ? 'Y' : 'N';

    emit('change', { id: props.inputId, value: newValue });
    emit('update:modelValue', newValue);
};
</script>
<template>
    <div
        v-if="visible"
        class="flex flex-col"
        :id="inputId"
        :style="{
            marginTop: marginTop,
            marginBottom: marginBottom,
            marginLeft: marginLeft,
            marginRight: marginRight
        }"
    >
        <label v-show="label !== 'N'" :class="['label-font mb-1 mx-1', required ? 'label-required' : 'text-gray-700 dark:text-gray-300']">
            {{ label }}
            <span v-if="required" class="required-asterisk">*</span>
            <span v-if="ValidationMsg" class="validation-message">{{ ValidationMsg }}</span>
        </label>
        <!-- <div
            class="w-full flex input-font whitespace-nowrap text-gray-900 border border-gray-300 rounded-lg bg-gray-60 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            :class="{
                'error-border': ValidationMsg,
                'text-right': props.number,
                'readonly-Bg': isReadonly
            }"
            :style="{ padding: padding }"
        > -->
        <div
            class="w-full flex input-font whitespace-nowrap"
            :class="{
                'error-border': ValidationMsg,
                'text-right': props.number,
                'readonly-Bg': isReadonly
            }"
        >
            <label class="relative inline-flex items-center cursor-pointer h-[2.5rem]">
                <input type="checkbox" value="" class="sr-only peer" @change="onChange" :checked="isChecked" :disabled="isReadonly || props.disabled" />
                <div
                    class="absolute w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#0038ea]"
                ></div>
                <span class="ms-3 block pl-10 font-medium text-gray-900 dark:text-gray-300" :style="{ 'font-size': props.spanSize }">
                    {{ spanText }}
                </span>
            </label>
        </div>
    </div>
</template>
<style scoped>
.label-font {
    font-family: 'SCoreDream600';
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    margin-bottom: 0.25rem;
    margin-left: 0.25rem;
    height: 1.3rem;
    white-space: nowrap;
    user-select: none;
}
.input-font {
    font-family: 'SCoreDream400';
    font-size: 0.9rem;
    user-select: none;
}
</style>
